import { Box, Button, Toolbar } from '@mui/material'
import { generatePath, useLocation, useNavigate, useParams } from 'react-router-dom'

import ComponentSize from '../../ComponentSize'

const SizeButtons: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const onClick = (size: ComponentSize) => {
    navigate(generatePath(pathname, { ...params, size }))
  }
  return (
    <Box display="flex">
      <Box margin={0.5}>
        <Button onClick={() => onClick('small')} variant="outlined">
          Small
        </Button>
      </Box>
      <Box margin={0.5}>
        <Button onClick={() => onClick('medium')} variant="outlined">
          Medium
        </Button>
      </Box>
      <Box margin={0.5}>
        <Button onClick={() => onClick('large')} variant="outlined">
          Large
        </Button>
      </Box>
    </Box>
  )
}

const ComponentSizeHeader: React.FC = () => {
  return (
    <Toolbar>
      <SizeButtons />
    </Toolbar>
  )
}

export default ComponentSizeHeader
